export default __webpack_public_path__ + "static/media/email-sent.9ee590b6.svg";